import React from 'react'
import './App.css';
import Home from './pages';
import SignIn from './pages/signin'
import SignUp from './pages/signup'
import ForgotPassword from './pages/forgotpassword';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom'
import TermsPage from './pages/Terms';
import Library from './pages/library';
import AccountOverview from './pages/account';
import AboutPage from './pages/About';
import SupportPage from './pages/support';

function App() {
  return (
    <div className="App">
      <Router>
        <Routes>
          <Route path='/' element={<Home />} exact />
          <Route path='/signin' element={<SignIn />} exact />
          <Route path='/signup' element={<SignUp />} exact />
          <Route path='/reset' element={<ForgotPassword />} exact />
          <Route path='/account' element={<AccountOverview />} exact />
          <Route path='/about' exact element={<AboutPage />} />
          <Route path='/support' exact element={<SupportPage />} />
          <Route path='/termsofservice' exact element={<TermsPage />} />
          <Route path='/mylibrary' exact element={<Library />} />
        </Routes>
      </Router>
    </div>
  );
}

export default App;
